import React, { useState, useEffect } from 'react';

// === 100% WORKING IMAGES & 30 PRODUCTS ===
const generate30Products = () => {
  const categories = [
    { name: "Gold", prefix: "G", base: "Bridal Choker", price: "₹2,40,000" },
    { name: "Diamond", prefix: "D", base: "Solitaire Ring", price: "₹1,10,000" },
    { name: "Platinum", prefix: "P", base: "Love Band", price: "₹85,000" },
    { name: "Silver", prefix: "S", base: "Antique Payal", price: "₹12,000" }
  ];
  
  const imgs = [
    "1601121141461-9d6647bca1ed", // Gold Choker
    "1605100804763-247f67b3557e", // Ring
    "1610492421973-e6ff984188eb", // Silver/Necklace
    "1629227355409-9069d3f18e90", // Bangle
    "1515562141207-7a88fb7ce338", // Luxury Jewelry
    "1535632066927-ab7c9ab60908"  // Diamond Studs
  ];

  let items = [];
  for (let i = 1; i <= 30; i++) {
    const cat = categories[i % categories.length];
    items.push({
      id: `${cat.prefix}${100 + i}`,
      cat: cat.name,
      name: `${cat.name} ${cat.base} v${i}`,
      price: cat.price,
      img: `https://images.unsplash.com/photo-${imgs[i % imgs.length]}?q=80&w=600&auto=format&fit=crop`,
      purity: cat.name === "Gold" ? "22K BIS" : "Certified"
    });
  }
  return items;
};

const allProducts = generate30Products();

const RajJewellers: React.FC = () => {
  type Page = 'home' | 'collections' | 'about' | 'contact';
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [filter, setFilter] = useState('All');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  }, [currentPage]);

  const filteredProducts = filter === 'All' ? allProducts : allProducts.filter(p => p.cat === filter);

  const openEnquiry = (product: any) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#FFFBF9] text-stone-900 font-sans overflow-x-hidden selection:bg-amber-100">
      
      {/* 1. TOP RATE STRIP (Responsive) */}
      <div className="bg-[#1A1A1A] text-amber-500 py-2 px-4 text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] text-center border-b border-stone-800">
          <span className="inline-block animate-pulse">✨ BIS Hallmarked • 100% Purity • Live Gold Rate (22K): ₹7,140/gm</span>
      </div>

      {/* 2. NAVBAR (Fully Responsive) */}
      <nav className="sticky top-0 z-[100] bg-white/90 backdrop-blur-md border-b border-amber-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-20 md:h-24 flex items-center justify-between">
          
          {/* Logo Brand */}
          <div className="flex flex-col items-center cursor-pointer group" onClick={() => setCurrentPage('home')}>
             <div className="text-amber-600 text-lg leading-none -mb-1">👑</div>
             <span className="text-2xl md:text-4xl font-serif font-black tracking-tighter text-stone-950 uppercase">RAJ <span className="text-amber-600 font-light">JEWELLERS</span></span>
             <div className="w-full h-[1px] bg-amber-200 scale-x-50 group-hover:scale-x-100 transition duration-500"></div>
          </div>
          
          {/* Desktop Links */}
          <div className="hidden lg:flex gap-10 text-[11px] font-bold uppercase tracking-[0.25em] text-stone-500">
            {['home', 'collections', 'about', 'contact'].map(page => (
              <button key={page} onClick={() => setCurrentPage(page as Page)} className={`hover:text-amber-600 transition ${currentPage === page ? 'text-stone-950 border-b-2 border-amber-600' : ''}`}>{page}</button>
            ))}
          </div>

          <div className="flex items-center gap-4">
             <button onClick={() => setCurrentPage('contact')} className="hidden sm:block bg-stone-950 text-white px-6 md:px-8 py-2.5 text-[10px] font-bold uppercase tracking-widest hover:bg-amber-600 transition">Book Visit</button>
             <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-3xl text-amber-700">☰</button>
          </div>
        </div>

        {/* Mobile Sidebar/Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden absolute top-20 left-0 w-full bg-white border-b border-amber-100 shadow-2xl p-6 flex flex-col gap-4 animate-fadeIn">
            {['home', 'collections', 'about', 'contact'].map(page => (
              <button key={page} onClick={() => setCurrentPage(page as Page)} className={`text-left py-3 text-xs font-bold uppercase tracking-widest border-b border-stone-50 ${currentPage === page ? 'text-amber-600' : 'text-stone-500'}`}>{page}</button>
            ))}
            <button onClick={() => setCurrentPage('contact')} className="w-full bg-stone-950 text-white py-4 text-xs font-bold uppercase tracking-widest mt-4">WhatsApp Enquiry</button>
          </div>
        )}
      </nav>

      <main className="animate-fadeIn">
        
        {/* ================= 1. HOME PAGE (MASSIVE & RESPONSIVE) ================= */}
        {currentPage === 'home' && (
          <div>
            {/* Hero Section */}
            <header className="relative min-h-[80vh] md:h-[90vh] flex items-center overflow-hidden bg-stone-900 px-6 py-20">
               <div className="absolute inset-0">
                 <img src="https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=1600" className="w-full h-full object-cover opacity-50" alt="Banner"/>
                 <div className="absolute inset-0 bg-gradient-to-r from-stone-950 via-stone-950/40 to-transparent"></div>
               </div>
               <div className="relative z-10 max-w-7xl mx-auto w-full">
                 <div className="max-w-3xl space-y-6 md:space-y-8 animate-slideUp">
                   <span className="text-amber-500 font-bold tracking-[0.3em] md:tracking-[0.5em] uppercase text-[10px] md:text-xs border-l-4 border-amber-600 pl-4">The Crown Jewel of Indore</span>
                   <h1 className="text-4xl sm:text-6xl md:text-9xl font-serif text-white leading-tight">Purity <br/><span className="italic font-light text-amber-400">Perfected.</span></h1>
                   <p className="text-stone-300 text-sm md:text-xl font-light max-w-lg leading-relaxed">Handcrafting emotions into timeless ornaments since 1992. Experience Indore's most trusted luxury jewellery house.</p>
                   <div className="pt-4 flex flex-col sm:flex-row gap-4">
                     <button onClick={() => setCurrentPage('collections')} className="bg-amber-600 text-stone-950 px-10 py-4 font-bold uppercase tracking-widest text-[10px] hover:bg-white transition">Explore Designs</button>
                     <button onClick={() => setCurrentPage('contact')} className="border border-white/50 text-white px-10 py-4 font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition">Book Virtual Viewing</button>
                   </div>
                 </div>
               </div>
            </header>

            {/* Heritage Section */}
            <section className="py-20 md:py-32 px-6 bg-white overflow-hidden">
               <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 md:gap-20 items-center">
                  <div className="relative">
                    <img src="https://images.unsplash.com/photo-1610492421973-e6ff984188eb?q=80&w=800" className="w-full h-[400px] md:h-[600px] object-cover rounded shadow-2xl" alt="Heritage"/>
                    <div className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 bg-amber-600 p-8 md:p-12 text-white">
                       <p className="text-3xl md:text-5xl font-serif">32+</p>
                       <p className="text-[10px] uppercase tracking-widest font-bold">Years of Trust</p>
                    </div>
                  </div>
                  <div className="space-y-6 md:space-y-8">
                     <h2 className="text-3xl md:text-5xl font-serif text-stone-950">A Legacy of <br/> Excellence.</h2>
                     <p className="text-stone-600 text-base md:text-lg leading-relaxed font-light">Every piece at RAJ Jewellers goes through 5 levels of quality checks. From the heart of Sarafa Bazaar to your wedding day, we ensure that your investment is as pure as your love.</p>
                     <div className="space-y-4">
                        {['100% BIS Hallmarked Gold', 'GIA & IGI Certified Diamonds', 'Lifetime Buy-back Policy'].map(item => (
                           <div key={item} className="flex gap-4 items-center border-b border-stone-100 pb-4">
                             <span className="text-amber-600 text-xl">✓</span>
                             <p className="text-xs md:text-sm font-bold uppercase tracking-widest">{item}</p>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            </section>
          </div>
        )}

        {/* ================= 2. COLLECTIONS (30 PRODUCTS - RESPONSIVE GRID) ================= */}
        {currentPage === 'collections' && (
          <div className="animate-slideUp pb-32">
            <div className="bg-[#1A1A1A] py-16 md:py-24 px-6 text-center text-white">
               <h1 className="text-4xl md:text-6xl font-serif mb-4 uppercase tracking-tighter">Masterpiece Gallery</h1>
               <p className="text-amber-500 font-bold tracking-[0.2em] uppercase text-[10px]">30 Designs • Pure Integrity • Certified Excellence</p>
            </div>
            
            {/* Horizontal Filter for Mobile */}
            <div className="max-w-7xl mx-auto px-4 md:px-6 mt-10 overflow-x-auto no-scrollbar whitespace-nowrap flex md:justify-center gap-6 md:gap-10 border-b border-stone-200 pb-6">
               {['All', 'Gold', 'Diamond', 'Platinum', 'Silver'].map(cat => (
                 <button key={cat} onClick={() => setFilter(cat)} className={`text-[10px] md:text-xs font-black uppercase tracking-[0.2em] pb-2 transition ${filter === cat ? 'text-amber-600 border-b-2 border-amber-600' : 'text-stone-400'}`}>{cat}</button>
               ))}
            </div>

            {/* Smart Grid for Products */}
            <div className="max-w-7xl mx-auto px-4 md:px-6 mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-8 md:gap-x-12">
              {filteredProducts.map(p => (
                <div key={p.id} className="group cursor-pointer">
                  <div className="relative aspect-[3/4] overflow-hidden bg-white shadow-sm border border-stone-100 p-2 md:p-3 transition duration-700">
                    <img src={p.img} className="w-full h-full object-cover group-hover:scale-105 transition duration-[1.5s]" alt={p.name}/>
                    <div className="absolute top-4 left-4 bg-stone-950 text-white text-[8px] font-black uppercase tracking-widest px-2 py-1">{p.cat}</div>
                  </div>
                  <div className="mt-6 text-center space-y-2">
                    <h3 className="text-lg md:text-xl font-serif text-stone-900">{p.name}</h3>
                    <p className="text-[10px] text-stone-400 font-bold uppercase tracking-widest">{p.purity} • ID: {p.id}</p>
                    <p className="text-lg font-serif text-amber-700">{p.price}</p>
                    <button onClick={() => openEnquiry(p)} className="mt-3 border-b border-amber-600 text-[10px] font-black uppercase tracking-widest text-amber-700 pb-1 hover:text-stone-950 transition">Get Details ➔</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ================= 3. ABOUT PAGE (RESPONSIVE SECTIONS) ================= */}
        {currentPage === 'about' && (
          <div className="animate-slideUp pb-32">
             <div className="bg-stone-50 py-16 md:py-24 px-6 text-center border-b border-stone-200">
                <h1 className="text-4xl md:text-6xl font-serif text-stone-950 mb-6">Our Legacy</h1>
                <p className="text-stone-500 max-w-2xl mx-auto text-base md:text-lg font-light italic">"Jewellery is more than an ornament; it's an heirloom of love passed through generations."</p>
             </div>

             <div className="max-w-7xl mx-auto px-6 mt-16 md:mt-24 space-y-24 md:space-y-32">
                <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
                   <div className="space-y-6 text-center md:text-left">
                      <h2 className="text-3xl md:text-4xl font-serif text-stone-950 uppercase">Indore's Trusted Name</h2>
                      <p className="text-stone-600 leading-relaxed text-sm md:text-lg font-light">Founded by Mr. Raj Kumar in 1992, we have remained Indore's favorite for bridal collections for over three decades.</p>
                      <div className="flex justify-center md:justify-start gap-8 md:gap-12 pt-4">
                         <div><p className="text-2xl md:text-3xl font-serif text-amber-600">30k+</p><p className="text-[8px] md:text-[10px] font-bold uppercase text-stone-400">Happy Brides</p></div>
                         <div><p className="text-2xl md:text-3xl font-serif text-amber-600">100%</p><p className="text-[8px] md:text-[10px] font-bold uppercase text-stone-400">Hallmarked</p></div>
                      </div>
                   </div>
                   <div className="h-[300px] md:h-[500px] rounded overflow-hidden shadow-xl">
                      <img src="https://images.unsplash.com/photo-1544025162-831665a3962b?q=80&w=800" className="w-full h-full object-cover" alt="Workshop"/>
                   </div>
                </div>
             </div>
          </div>
        )}

        {/* ================= 4. CONTACT & FOOTER ================= */}
        {currentPage === 'contact' && (
          <div className="animate-slideUp py-12 md:py-24 px-4 md:px-6 bg-[#FDF7F5]">
            <div className="max-w-5xl mx-auto bg-white shadow-2xl flex flex-col md:flex-row overflow-hidden rounded">
               <div className="md:w-2/5 bg-[#1A1A1A] p-10 md:p-12 text-white flex flex-col justify-between">
                 <div className="space-y-10">
                   <h2 className="text-3xl md:text-4xl font-serif text-amber-500 leading-tight uppercase">Visit Our <br/>Showroom.</h2>
                   <div className="space-y-6 text-[10px] md:text-[11px] font-bold tracking-[0.2em] uppercase text-stone-400">
                     <p>📍 Sarafa Bazaar, Indore, MP</p>
                     <p>📞 +91 98765 43210</p>
                     <p>🕒 11:00 AM - 8:30 PM (Sun Closed)</p>
                   </div>
                 </div>
               </div>
               <div className="md:w-3/5 p-8 md:p-16">
                  <h3 className="text-2xl md:text-3xl font-serif mb-8 text-stone-900">Enquire Now</h3>
                  <form className="space-y-6" onSubmit={(e) => { e.preventDefault(); alert('Request Sent! We will contact you soon.'); }}>
                    <input required type="text" placeholder="Full Name" className="bg-stone-50 border-b border-stone-200 py-4 focus:border-amber-600 outline-none w-full text-sm transition"/>
                    <input required type="tel" placeholder="WhatsApp Number" className="bg-stone-50 border-b border-stone-200 py-4 focus:border-amber-600 outline-none w-full text-sm transition"/>
                    <button type="submit" className="w-full bg-[#1A1A1A] text-white py-4 md:py-5 font-black uppercase tracking-[0.3em] text-[10px] shadow-xl hover:bg-amber-600 transition">Check Price on WhatsApp</button>
                  </form>
               </div>
            </div>
          </div>
        )}
      </main>

      {/* --- SMART ENQUIRY POPUP (GLOBAL) --- */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-stone-950/80 backdrop-blur-sm" onClick={() => setIsModalOpen(false)}></div>
          <div className="relative bg-white w-full max-w-lg rounded-2xl shadow-2xl p-8 md:p-12 text-center animate-slideUp">
             <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-6 text-stone-400 text-3xl">×</button>
             <h3 className="text-2xl md:text-3xl font-serif text-stone-900 mb-2">Check Availability</h3>
             <p className="text-amber-600 font-bold uppercase tracking-widest text-[10px] mb-8">Item: {selectedProduct?.name}</p>
             <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); setIsModalOpen(false); alert('Enquiry Sent!'); }}>
                <input required type="text" placeholder="Full Name" className="w-full bg-stone-50 border border-stone-100 p-4 rounded-xl text-sm outline-none focus:border-amber-600 transition"/>
                <input required type="tel" placeholder="WhatsApp Number" className="w-full bg-stone-50 border border-stone-100 p-4 rounded-xl text-sm outline-none focus:border-amber-600 transition"/>
                <button type="submit" className="w-full bg-stone-950 text-white py-4 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-amber-600 transition">Confirm Enquiry</button>
             </form>
          </div>
        </div>
      )}

      {/* --- MEGA FOOTER (RESPONSIVE) --- */}
      <footer className="bg-[#0A0A0A] text-stone-500 py-20 px-6 border-t-[6px] border-amber-600">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6 space-y-6 text-center md:text-left">
            <span className="text-3xl md:text-4xl font-serif font-black text-white tracking-tighter">RAJ JEWELLERS</span>
            <p className="text-sm font-light leading-relaxed max-w-sm mx-auto md:mx-0">Indore's premier destination for luxury bridal gold and certified diamonds. Purity and Trust for 32+ Years.</p>
            <div className="flex justify-center md:justify-start gap-6 pt-4 font-bold text-[10px] text-white">
              <span>INSTAGRAM</span> <span>FACEBOOK</span> <span>WHATSAPP</span>
            </div>
          </div>
          
          <div className="lg:col-span-3 space-y-6 text-center md:text-left">
             <h4 className="font-bold text-white uppercase tracking-[0.2em] text-xs">Explore</h4>
             <ul className="space-y-4 text-[11px] font-bold uppercase tracking-widest">
                <li><button onClick={() => setCurrentPage('home')} className="hover:text-amber-600">Our Heritage</button></li>
                <li><button onClick={() => setCurrentPage('collections')} className="hover:text-amber-600">Bridal Collection</button></li>
                <li><button onClick={() => setCurrentPage('collections')} className="hover:text-amber-600">Certified Diamonds</button></li>
             </ul>
          </div>

          <div className="lg:col-span-3 space-y-6 text-center md:text-left">
             <h4 className="font-bold text-white uppercase tracking-[0.2em] text-xs">Visit</h4>
             <p className="text-xs leading-loose font-light">42-A, Main Sarafa Bazaar,<br/>Indore, MP - 452001</p>
             <p className="text-amber-600 font-bold text-sm">+91 98765 43210</p>
          </div>
        </div>
        <div className="max-w-7xl mx-auto border-t border-stone-900 mt-16 pt-8 text-[10px] text-center uppercase tracking-widest text-stone-600">
           © {new Date().getFullYear()} RAJ JEWELLERS. MADE FOR PREMIUM PORTFOLIO.
        </div>
      </footer>

      {/* Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .animate-slideUp { animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}} />
    </div>
  );
};

export default RajJewellers;